( function( app ) {
  const COMPONENT = {
    init: function() {},
    finalize: function() {},
  };

  app.registerComponent( 'graphic-list', COMPONENT );
} )( app );
